import React from 'react';
import MorphButton from '@/components/auth/MorphButton';
import { Gift, Coins, Star, Sparkles } from 'lucide-react';

const NAVY = '#1A2744';
const GOLD = '#C9A227';

const STEPS = [
  { icon: Coins, text: 'Earn points every time you order or spend in store' },
  { icon: Gift, text: 'Turn your points into money off your next order' },
  { icon: Star, text: 'Hit 2,500 points in a year to unlock Gold perks' }
];

/**
 * Shown at the end of onboarding when the new user has no loyalty account yet.
 * Joins them to Peony Rewards directly — no second tap on the Loyalty page.
 */
export default function LoyaltyJoinPrompt({ onJoin, onSkip, joining = false }) {
  return (
    <div className="text-center">
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
        style={{ backgroundColor: '#FDF8EA' }}
      >
        <Sparkles className="w-7 h-7" style={{ color: GOLD }} />
      </div>

      <h1 className="text-2xl font-bold mb-2" style={{ color: NAVY }}>
        Join Peony Rewards
      </h1>
      <p className="text-sm text-gray-500 mb-5">
        You're not a rewards member yet — join now and we'll drop{' '}
        <span className="font-semibold" style={{ color: GOLD }}>50 free points</span> straight
        into your account as a new member.
      </p>

      <div className="space-y-3 text-left mb-6">
        {STEPS.map(({ icon: Icon, text }, i) => (
          <div
            key={i}
            className="flex items-start gap-3 rounded-2xl border p-3"
            style={{ borderColor: '#E8DFC5' }}
          >
            <Icon className="w-5 h-5 mt-0.5 shrink-0" style={{ color: GOLD }} />
            <p className="text-sm text-gray-700">{text}</p>
          </div>
        ))}
      </div>

      <MorphButton onClick={onJoin} loading={joining} className="mb-3">Join & claim 50 points</MorphButton>

      <button onClick={onSkip} disabled={joining} className="w-full text-center text-gray-500 text-sm hover:text-gray-700 disabled:opacity-50">
        Maybe later
      </button>
    </div>
  );
}